import React, { useEffect } from 'react';
import { DivPropsWithoutRef } from '../../common/types';
import { IconButton, IconButtonVariant } from '../IconButton';
import { IconActionDelete } from '../../icons';
import clsx from 'clsx';

export interface BaseModalProps extends Omit<DivPropsWithoutRef, 'style'> {
  /**
   * Обработчик клика на кнопку закрытия
   */
  onCloseClick?: () => void;
  /**
   * Произвольные классы элементов:
   * * wrapper – контейнер контента
   * * closeButton – иконка закрытия
   */
  classes?: {
    wrapper?: string;
    closeButton?: string;
  };
  /**
   * Произвольные стили модального окна
   */
  style?: React.CSSProperties;
}

export function BaseModal({
  children,
  onCloseClick,
  className,
  classes,
  ...props
}: BaseModalProps) {
  return (
    <div className={clsx('hse-BaseModal', className)} {...props}>
      <div className={clsx('hse-BaseModal__wrapper', classes?.wrapper)}>
        <IconButton
          icon={IconActionDelete}
          variant={IconButtonVariant.ghost}
          className={clsx('hse-BaseModal__closeButton', classes?.closeButton)}
          onClick={onCloseClick}
        />
        {children}
      </div>
    </div>
  );
}
